<template>
  <router-view/>
</template>

<style>
  @import url('./assets/css/app.css');
</style>
